import { SWReactIcons } from "@similarweb/icons";
import { StyledHeader, StyledIconWrapper, StyledText, StyledTitle, StyledTooltipContent } from "./styles";

type Props = {
    title: string;
    description: string;
};

const SignalInsightTooltipContent = ({ title, description }: Props) => {
    return (
        <StyledTooltipContent>
            <StyledHeader>
                <StyledIconWrapper>
                    <SWReactIcons iconName="light-bulb" />
                </StyledIconWrapper>
                <StyledTitle>{title}</StyledTitle>
            </StyledHeader>

            <StyledText>{description}</StyledText>
        </StyledTooltipContent>
    );
};

export default SignalInsightTooltipContent;
